import { canonicalFilaCsvToken, tokenFieldKind } from "./filaCsvTokens.util";

/**
 * Filtro de contas contábeis / resultado no catálogo (relatorios_filtros).
 * @param {{ nome?: string, variavel?: string, tipoDado?: string, tipo_dado?: string }} filtro
 */
export function isFiltroContasContabeis(filtro) {
  const nome = String(filtro?.nome ?? "");
  const variavel = String(filtro?.variavel ?? "").toLowerCase();
  const tipo = String(filtro?.tipoDado ?? filtro?.tipo_dado ?? "").toLowerCase();

  if (tipo === "autocomplete_dependencia") return true;
  if (tokenFieldKind(canonicalFilaCsvToken(filtro?.variavel)) === "contas") {
    return true;
  }
  if (/contas?\s+cont[aá]beis/i.test(nome) || /conta\s+cont[aá]bil/i.test(nome)) {
    return true;
  }
  if (
    variavel.includes("contas_contabil") ||
    variavel.includes("contas_contabeis")
  ) {
    return true;
  }
  return false;
}

/**
 * Exibe/obriga contas na modal quando o catálogo tem filtro de contas com required = true.
 * @param {Array<{ nome?: string, variavel?: string, tipoDado?: string, tipo_dado?: string, required?: boolean }>} [filtros]
 */
export function relatorioPrecisaContasResultado(_relatorio, filtros = []) {
  return filtros.some(
    (f) => f.required === true && isFiltroContasContabeis(f)
  );
}

function filtroRequiredAtivo(filtro) {
  return filtro?.required === true;
}

/**
 * Catálogo possui filtro de data inicial (${dt_inicial}).
 */
export function relatorioTemFiltroDataInicial(filtros = []) {
  return filtros.some(
    (f) =>
      filtroRequiredAtivo(f) &&
      tokenFieldKind(canonicalFilaCsvToken(f?.variavel)) === "dataInicial"
  );
}

/**
 * Catálogo possui filtro de data final (${dt_final}) obrigatório.
 */
export function relatorioTemFiltroDataFinal(filtros = []) {
  return filtros.some(
    (f) =>
      filtroRequiredAtivo(f) &&
      tokenFieldKind(canonicalFilaCsvToken(f?.variavel)) === "dataFinal"
  );
}
